import { logWrapper } from '../../utils';

export default {
  authInterceptorService: [
    'runtimeConstant',
    '$q',
    '$injector',
    '$location',
    'webApiSettings',
    function (runtimeConstant, $q, $injector, $location, webApiSettings) {
      'use strict';

      function request(response) {
        response.headers = response.headers || {};

        var authService = $injector.get('authService');
        var authData = authService.authentication;

        if (
          response.url !== webApiSettings.apiServiceBaseUri + 'token' &&
          authData.token !== null &&
          authData.token !== ''
        ) {
          response.headers.Authorization = 'Bearer ' + authData.token;
        }

        return response;
      }

      function responseError(rejection) {
        if (rejection.status === 401) {
          var authService = $injector.get('authService');

          authService.logOut();

          $location.path('/login');
          rejection.status = 403;
        }

        if (rejection.status === 0) rejection.status = 404;
        return $q.reject(rejection);
      }

      function run() {
        try {
          return {
            request: logWrapper(
              request,
              runtimeConstant.isDebugServicesInternals
            ),
            responseError: logWrapper(
              responseError,
              runtimeConstant.isDebugServicesInternals
            ),
          };
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
